import axios from 'axios'

import { actionCreators } from './reducers/login/loginReducer'
import { actionCreators as networkActionCreators } from './reducers/networkStatus/networkStatusReducer'
import Cache from 'js-cache'
const cache = new Cache({
  set: (key, value, ttl) =>
    localStorage.setItem('cache-' + key, JSON.stringify({ value, ttl })),
  get: (key, callback) => {
    try {
      const storedItem = JSON.parse(
        localStorage.getItem('cache-' + key) || '{}'
      )
      if (new Date(storedItem.ttl).toISOString() > new Date().toISOString()) {
        localStorage.removeItem('cache-' + key)
        return callback(null)
      }
      return callback(storedItem.value)
    } catch (e) {
      return callback(null)
    }
  },
  del: key => localStorage.removeItem('cache-' + key),
  clear: () => {
    for (var key in localStorage) {
      if (key.match(/^cache-/)) {
        localStorage.removeItem(key)
      }
    }
  }
})

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/',
  timeout: 30000,
  headers: {}
})

instance.interceptors.request.use(
  function (config) {
    const getReduxStore = require('../index').getReduxStore
    getReduxStore().dispatch(networkActionCreators.increment())

    const token = window.sessionStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    config.headers['Content-type'] = 'application/json'
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => {
    const getReduxStore = require('../index').getReduxStore
    getReduxStore().dispatch(networkActionCreators.decrement())
    return response
  },
  function (error) {
    const getReduxStore = require('../index').getReduxStore
    getReduxStore().dispatch(networkActionCreators.decrement())
    try {
      if (error.response.status === 401) {
        getReduxStore().dispatch(actionCreators.reset())
      }
    } catch (e) {
      console.error('axios error', e)
    }

    // Do something with response error
    return Promise.reject(error)
  }
)

const cachePatterns = [/\/districts/, /\/courses\//]
instance.interceptors.request.use(request => {
  // Only cache GET requests
  if (
    request.method === 'get' &&
    cachePatterns.find(p => request.url.match(p))
  ) {
    let url = request.url
    if (request.params) url += '?' + param(request.params)
    const _cached = cache.get(url)
    if (_cached) {
      _cached.__fromCache = true
      console.log(`"${url}" served from cache:`)
      request.data = _cached
      // Set the request adapter to send the cached response and prevent the request from actually running
      request.adapter = () => {
        return Promise.resolve({
          data: _cached,
          status: request.status,
          statusText: request.statusText,
          headers: request.headers,
          config: request,
          request: request
        })
      }
    }
  }

  return request
})
// const cacheTimeInMinutes = 5
const cacheTimeInMS = 60000 * 5
instance.interceptors.response.use(
  response => {
    // if you dont want to cache a specific url, send a param `__cache = false`
    const isCacheable =
      !response.config.params ||
      (response.config.params && response.config.params.__cache !== false)

    if (cachePatterns.find(p => response.config.url.match(p)) && isCacheable) {
      let url = response.config.url

      if (response.config.params) url += '?' + param(response.config.params)

      if (response.config.method === 'get') {
        // On get request, store the response in the cache
        cache.set(url, response.data, cacheTimeInMS)
      } else {
        // For post, put or delete, just delete the cached version of the url
        // e.g. posting to `/users` would delete the `/users` cache, so when you ask for users again you get the real version
        // cache.del(response.config.url)
        // // also, when making a post,put or delete request to `/users/1`, would try to delete the `/users` for the same reason
        // const uri = url.replace(config.http.api.base_url, ''),
        //   parentUri = /(.*)\/([a-z0-9\-]+)\/?$/gi.exec(uri)
        // if (parentUri) cache.del(`${config.http.api.base_url}${parentUri[1]}`)
        // // Delete similar url that just have query string diferences
        // // Specially useful for things like Laravel's `with` param
        // // e.g. `/users?with=permissions` will get cached but the post to `/users` wont remove it from the cache
        // // so I look all the cached url's and try to match it without the querystrings
        // const urls = Object.keys(cache.debug())
        // for (const _url of urls) {
        //   if (_url.match(/^[^?]+/)[0] === response.config.url) cache.del(_url)
        // }
      }
    }
    return response
  },
  error => Promise.reject(error)
)

export default instance

const param = a =>
  Object.keys(a)
    .map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(a[k])
    })
    .join('&')



// WEBPACK FOOTER //
// ./src/redux/axios.js